import { render, staticRenderFns } from "./password_trans.vue?vue&type=template&id=6ebe892e&scoped=true&"
import script from "./password_trans.vue?vue&type=script&lang=js&"
export * from "./password_trans.vue?vue&type=script&lang=js&"
import style0 from "./password_trans.vue?vue&type=style&index=0&id=6ebe892e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ebe892e",
  null
  
)

export default component.exports